/* eslint-disable @typescript-eslint/naming-convention */
import { ProductThumbnailType2 } from "@/components/commons/productThumbnailType2"
import { Box } from "@chakra-ui/react"
import { useMediaQuery } from "@uidotdev/usehooks"
import React, { useMemo } from "react"
import { useNavigate } from "react-router-dom"
import image from "../../assets/images/cast-in-fire-collars.webp"
import { COLLARTYPEKEY, breadCrumbFirstLevel, breadCrumbProductsSecondLevel, mobileBreakpoint } from "../../common/commonConstants"
import { SubPage, SubPageContent } from "../../components/SubPage"
import { BannerType1 } from "../../components/commons/bannerType1"
import { BreadCrumb } from "../../components/commons/breadcrumb"
import { Heading2CapsSubText } from "../../components/commons/heading2CapsSubText"
import { Loading } from "../../components/commons/loader.main"
import { chakraTheme } from "../../theme/chakraTheme"
import { useAllCollarsQuery, type Product4Menu } from "../../type-and-hooks"

export const FloorwasteAndShower = (): JSX.Element => {
  const { loading, data } = useAllCollarsQuery({ variables: { collarTypeId: COLLARTYPEKEY.CASTIN }, fetchPolicy: "cache-and-network" })
  const navigate = useNavigate()
  const isMobile = useMediaQuery(`(max-width: ${mobileBreakpoint}px)`)
  const columnCount = isMobile ? 2 : 3

  const handleClick = (item: Product4Menu | undefined | null): void => {
    if (item?.pid) {
      navigate(item.prod_link ?? "/", { state: { pid: item.pid, catName: "Floor Waste & Shower", prodCode: item.prod_code } })
    } else {
      console.error("Product is not available", item)
    }
  }

  const collars = useMemo(
    () =>
      (data?.allCollars ?? []).filter(
        (item): item is Product4Menu => item != null && item.subcategory?.toLowerCase().includes("floor waste") === true
      ),
    [data?.allCollars]
  )

  return (
    <SubPage>
      <BannerType1
        heading="Floor Waste & Shower"
        subHeading="Cast-In Fire Collars"
        subText1="Available for floor waste and shower applications, in both low-top and high-top configurations."
        subText2="Can be used on conventional slabs, metal decks and in concrete beams."
        image={image}
        imageStyles={{ width: "265px", height: "330px" }}
      />
      <BreadCrumb
        options={{
          ...breadCrumbFirstLevel,
          ...breadCrumbProductsSecondLevel,
          thirdLevel: { title: "Fire Collar", path: "/all-products" },
          fourthLevel: { title: "Floorwaste & Shower" }
        }}
      />

      <SubPageContent props={{ mt: ["40px", "40px", "40px", 0, 0, 0] }}>
        <Box overflow={"hidden"} mb={["30px", "30px", "30px", "137px", "137px", "137px"]}>
          <Heading2CapsSubText
            headingTextStyles={{
              textAlign: "left",
              fontSize: ["24px", "24px", "24px", "24px"],
              fontWeight: 500,
              lineHeight: "24px",
              fontFamily: "Work Sans",
              pt: "10px",
              pb: "14px"
            }}
            subTextStyles={{ color: "#939598" }}
            headingText="Floorwaste & Shower"
            subText={`${collars.length} items`}
          />
          <Loading loading={loading} />
          <Box display="grid" gridTemplateColumns={[`repeat(${columnCount}, 1fr)`]} gap="8px">
            {collars.map((item, index) => (
              <React.Fragment key={`${index}_floorwaste`}>
                <ProductThumbnailType2
                  onClickCallBack={() => {
                    handleClick(item)
                  }}
                  prodCode={item?.prod_code}
                  prodPhoto={item?.prod_photo}
                  bg={chakraTheme.colors.lightGray}
                />
                <>{(index + 1) % columnCount === 0 && <Box my="16px" gridColumn={`span ${columnCount}`} height="1px" bg="primary"></Box>}</>
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </SubPageContent>
    </SubPage>
  )
}
